import { TFunction } from "i18next";
import { get } from "lodash";

import { TIndicatorReportsConfigForm } from "~/components/Forms/IndicatorReportsConfigForm";
import {
  formatReportDateBegin,
  formatReportDateEnd,
  indicatorReportConfigToParameters,
} from "~/components/Forms/IndicatorReportsConfigForm/lib";
import { TSelectItem } from "~/model/common";
import { TypeGroupDealerIndicatorValues } from "~/schemas/generated/graphql";

const getValueCollection = (
  instance: TSelectItem<string> | TSelectItem<string>[],
) => {
  if (Array.isArray(instance)) {
    return instance.map((element) => element.value);
  }
  if (instance?.value) return [instance.value];
};

export const indicatorReportHashGetterSerializer = (
  data: TIndicatorReportsConfigForm,
) => {
  return {
    ...data,
    dateBegin:
      data.dateBegin === null
        ? undefined
        : formatReportDateBegin(data.dateBegin),
    dateEnd:
      data.dateEnd === null ? undefined : formatReportDateEnd(data.dateEnd),
    quarter: data.quarter ? Number(data.quarter?.value) : undefined,
    year: data.year ? Number(data.year?.value) : undefined,
    DealerIds: getValueCollection(data.DealerIds),
    RegMenIds: getValueCollection(data.RegMenIds),
    HoldingIds: getValueCollection(data.HoldingIds),
    Country: getValueCollection(data.Country),
    FO: getValueCollection(data.FO),
    Region: getValueCollection(data.Region),
    City: getValueCollection(data.City),
  };
};

export const indicatorReportOpenPreview = (
  data: TIndicatorReportsConfigForm,
  currentReport: string,
) => {
  const origin = window.location.origin;
  const route = `/reports/view/${currentReport}`;
  const parameters = indicatorReportConfigToParameters(data);

  const url = origin + route + parameters;
  window.open(url, "_blank").focus();
};

export const handleIndicatorReportHash = (getReportHashState: unknown) =>
  get(
    getReportHashState,
    "data.IndicatorGroupReportGetter.getDealerIndicatorValuesTableHash.fileHash",
  );

export const REPORT_FILTER_FIELD_NAMES = {
  [TypeGroupDealerIndicatorValues.Dealer]: "DealerIds",
  [TypeGroupDealerIndicatorValues.Holding]: "HoldingIds",
  [TypeGroupDealerIndicatorValues.Regmen]: "RegMenIds",
  [TypeGroupDealerIndicatorValues.City]: "City",
  [TypeGroupDealerIndicatorValues.Region]: "Region",
  [TypeGroupDealerIndicatorValues.Fo]: "FO",
};

export const getIndicatorReportsFilterGroup = (
  t: TFunction,
): TSelectItem<TypeGroupDealerIndicatorValues>[] => [
  {
    value: TypeGroupDealerIndicatorValues.Dealer,
    label: t("reports.groupByDealer"),
  },
  {
    value: TypeGroupDealerIndicatorValues.Holding,
    label: t("reports.groupByHolding"),
  },
  {
    value: TypeGroupDealerIndicatorValues.Regmen,
    label: t("reports.groupByRegMen"),
  },
  {
    value: TypeGroupDealerIndicatorValues.City,
    label: t("reports.groupByCity"),
  },
  {
    value: TypeGroupDealerIndicatorValues.Region,
    label: t("reports.groupByRegion"),
  },
  {
    value: TypeGroupDealerIndicatorValues.Fo,
    label: t("reports.groupByFO"),
  },
];
